import {
  Swiper, EffectFade, Navigation, Lazy,
} from 'swiper';
import SimpleBar from 'simplebar';
import HideOffscreenSlides from '../../components/modules/swiper-hide-offscreen';

window.addEventListener('load', () => {
  // eslint-disable-next-line no-new
  new Swiper('.full-width-image-and-text__swiper.swiper', {
    loop: true,
    autoHeight: true,
    slidesPerView: 1,
    preloadImages: false,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      prevEl: '.full-width-image-and-text__button-prev',
      nextEl: '.full-width-image-and-text__button-next',
    },
    modules: [EffectFade, Navigation, Lazy, HideOffscreenSlides],
    lazy: {
      preloaderClass: 'c-slide-preloader',
      loadPrevNext: true,
    },
  });

  const postSlideContent = document.querySelector('.post .full-width-image-and-text .full-width-image-and-text__content');

  if (postSlideContent !== null) {
    // eslint-disable-next-line no-new
    new SimpleBar(postSlideContent);
  }
});
